import axios from "axios";
import config from "../config/config";
import store from "../store"

const API_URL = config.API_URL; 

export const Store = async (data) => {
    const token = store.state.authToken;
    let formData;
    if (typeof FormData !== 'undefined' && data instanceof FormData) {
        formData = data;
    } else {
        formData = new FormData();
        Object.entries(data || {}).forEach(([key, val]) => {
            if (val !== null && val !== undefined && val !== '') {
                formData.append(key, val);
            }
        });
    }
    const headers = {};
    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }
    const response = await axios.post(`${API_URL}auth/register`, formData, { headers });
    return response.data;
};
